import * as Yup from 'yup'
import Button from '../../../components/button/Button'
import './timeTableReport.scss'
import { ROUTES_PATH } from '../../../utility/constants'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import { ErrorMessage } from 'formik'
import Calendar from '../../../components/calendar/Calendar'
import { Form, Formik } from 'formik'
import { useEffect, useMemo, useRef, useState } from 'react'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import { useDispatch, useSelector } from 'react-redux'
import { getBranch } from '../../../store/builders/branch/branch.builder'
import {
  convertDateFormatCalendar,
  exportTimeTableReport,
  generateDropdownOptions,
} from '../../../utility/genricFunction'
import { getFaculty } from '../../../store/builders/faculty/faculty.builder'
import dayjs from 'dayjs'
import ReportDataTable from '../../../components/report-table/ReportDataTable'
import { getTimeTableReport } from '../../../store/builders/reports/reports.builder'
import PrintIcon from '@mui/icons-material/Print'
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload'
import { useReactToPrint } from 'react-to-print'
import Loader from '../../../components/loader/Loader'
import { CircularProgress } from '@mui/material'
import { toast } from 'react-toastify'

const TimeTableReport = () => {
  const [showTable, setShowTable] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [selectedFaculty, setSelectedFaculty] = useState('')
  const [selectedBranch, setSelectedBranch] = useState('')
  const [mailPayload, setMailPayload] = useState({
    startDate: '',
    endDate: '',
    faculties: '',
  })
  const dispatch = useDispatch()
  const branches = useSelector((state) => state?.branch?.branchTableData)
  const { loading, mailLoading } = useSelector((state) => state?.reports)
  const faculties = useSelector((state) => state?.faculty?.facultyData)
  // const pageDropDownLoading = useSelector((state) => state?.faculty)
  const timeTableReport = useSelector((store) => store?.reports?.timeTableReport)

  const userRole = useSelector((store) => store?.auth?.user?.result?.userData?.roleName)
  const branchId = useSelector((store) => store?.auth?.user?.result?.userData?.branchId)

  const printRef = useRef(null)

  const [initialValues] = useState({
    fromDate: '',
    toDate: '',
    branch: userRole == 'branch' ? branchId : '',
    faculty: '',
  })

  const validationSchema = Yup.object().shape({
    fromDate: Yup.date().required('From Date is required'),
    toDate: Yup.date().required('To Date is required'),
    branch: Yup.string().required('Branch is required'),
    faculty: Yup.string().required('Faculty is required'),
  })

  useEffect(() => {
    dispatch(getBranch('active'))
    dispatch(getFaculty())
  }, [dispatch])

  const branchOption = useMemo(() => generateDropdownOptions(branches, 'branchName', 'branchId'), [branches])
  const facultyOptions = useMemo(() => generateDropdownOptions(faculties, 'userName', 'facultyId'), [faculties])
  const allFacultyOption = [{ label: 'All', value: 'all' }, ...facultyOptions]

  const disableNonMondays = (date) => {
    return date.day() !== 1
  }

  const breadCrumbsArr = [
    {
      title: 'Timetable Report',
      link: null,
    },
    {
      title: 'Dashboard',
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: 'TimeTable Report',
      link: ROUTES_PATH.TIMETABLE_REPORT,
    },
  ]

  const columns = [
    {
      field: 'batch',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Batch</p>
          <span></span>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem', textAlign: 'center' },
    },
    {
      field: 'Monday',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Monday</p>
          <p>{dayjs(startDate).format('DD-MM-YYYY')}</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem', textAlign: 'center' },
    },
    {
      field: 'Tuesday',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Tuesday</p>
          <p>{dayjs(startDate).add(1, 'd').format('DD-MM-YYYY')}</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem', textAlign: 'center' },
    },
    {
      field: 'Wednesday',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Wednesday</p>
          <p>{dayjs(startDate).add(2, 'd').format('DD-MM-YYYY')}</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem', textAlign: 'center' },
    },
    {
      field: 'Thursday',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Thursday</p>
          <p>{dayjs(startDate).add(3, 'd').format('DD-MM-YYYY')}</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem', textAlign: 'center' },
    },
    {
      field: 'Friday',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Friday</p>
          <p>{dayjs(startDate).add(4, 'd').format('DD-MM-YYYY')}</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem', textAlign: 'center' },
    },
    {
      field: 'Saturday',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Saturday</p>
          <p>{dayjs(startDate).add(5, 'd').format('DD-MM-YYYY')}</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem', textAlign: 'center' },
    },
    {
      field: 'Sunday',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Sunday</p>
          <p>{dayjs(startDate).add(6, 'd').format('DD-MM-YYYY')}</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem', textAlign: 'center' },
    },
  ]

  const handleDownloadPfd = useReactToPrint({
    content: () => printRef.current,
  })

  const getReportDataRender = (timeTableReport) => {
    const weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

    return timeTableReport.map((report) => {
      const formattedData = report.batchWiseTimetable.map((batch) => {
        const batchData = { batch: batch.batchName }

        weekDays.forEach((day) => {
          const dayData = batch.timetableData.filter((entry) => entry.day === day)
          if (dayData.length > 0) {
            batchData[day] = dayData.map((entry, index) => (
              <div style={{ lineHeight: '22px' }} key={index}>
                <div>{entry.facultyName}</div>
                <div style={{ fontWeight: 'bolder', color: 'black' }}>{entry.moduleName}</div>
                <div>{entry.className}</div>
                {entry.type === 'online_exam' && <div className='online-exam-bg'>Online Exam</div>}
                {entry.type === 'offline_exam' && <div className='offline-exam-bg'>Offline Exam</div>}
              </div>
            ))
          } else {
            batchData[day] = '—'
          }
        })

        return batchData
      })

      return {
        classTime: report.classTime,
        data: formattedData,
      }
    })
  }

  const getReportData = (timeTableReport) => {
    const weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

    return timeTableReport.map((report) => {
      const formattedData = report.batchWiseTimetable.map((batch) => {
        const batchData = { batch: batch.batchName }

        weekDays.forEach((day) => {
          const dayData = batch.timetableData.filter((entry) => entry.day === day)
          if (dayData.length > 0) {
            batchData[day] = dayData
              .map(
                (entry) =>
                  `${entry.facultyName}\n${entry.moduleName}\n${entry.className}\n${entry.type === 'online_exam' ? 'Online Exam' : entry.type === 'offline_exam' ? 'Offline Exam' : ''}`,
              )
              .join('\n\n')
          } else {
            batchData[day] = '—'
          }
        })

        return batchData
      })

      return {
        classTime: report.classTime,
        data: formattedData,
      }
    })
  }

  return (
    <>
      {loading && <Loader loading={loading} />}
      {<Loader loading={loading} /> && (
        <div className='time-table-report-wrapper'>
          <Formik
            validationSchema={validationSchema}
            initialValues={initialValues}
            enableReinitialize
            onSubmit={(value) => {
              setShowTable(true)
              setStartDate(value.fromDate)
              setSelectedFaculty(value.faculty)
              setSelectedBranch(value.branch)
              setMailPayload({
                startDate: value.fromDate,
                endDate: value.toDate,
                faculties: value.faculty,
              })
              const data = {
                branchId: value.branch,
                startDate: value.fromDate,
                endDate: value.toDate,
                faculties: value.faculty,
              }
              dispatch(getTimeTableReport(data))
            }}
          >
            {({ values, handleChange, setValues }) => (
              <Form>
                <div className='time-table-report-header'>
                  <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
                </div>
                <div className='time-table-report-main-div'>
                  <div className='time-table-report-input-fields'>
                    <Calendar
                      label='From Date'
                      name='fromDate'
                      required={true}
                      width={'25%'}
                      onChange={(values) => {
                        setValues({
                          fromDate: convertDateFormatCalendar(values),
                          toDate: dayjs(convertDateFormatCalendar(values)).add(6, 'd').toISOString(),
                          branch: userRole == 'branch' ? branchId : '',
                        })
                      }}
                      shouldDisableDate={disableNonMondays}
                    />
                    <Calendar
                      label='To Date'
                      name='toDate'
                      required={true}
                      width={'25%'}
                      disabled={true}
                      value={values.toDate}
                    />
                    <div className='time-table-report-dropdown'>
                      <label htmlFor=''>
                        Branch<span className='required-symbol'>*</span>
                      </label>
                      <PageDropdown
                        // loading={pageDropDownLoading}
                        className={'facultyForm-dropdown'}
                        name={'branch'}
                        placeholder={'Select Branch'}
                        options={branchOption}
                        selectedValue={values.branch}
                        onChange={handleChange}
                        disabled={userRole == 'branch'}
                      />
                      <ErrorMessage name='branch' component='div' className='error-msg' />
                    </div>
                    <div className='time-table-report-dropdown'>
                      <label htmlFor=''>
                        Faculty<span className='required-symbol'>*</span>
                      </label>
                      <PageDropdown
                        // loading={pageDropDownLoading}
                        options={allFacultyOption}
                        selectedValue={values.faculty}
                        className={'facultyForm-dropdown'}
                        name={'faculty'}
                        placeholder={'Select Faculty'}
                        onChange={handleChange}
                      />
                      <ErrorMessage name='faculty' component='div' className='error-msg' />
                    </div>
                  </div>

                  <div className='submit-btn-wrapper'>
                    <Button customClassName={'tt-report-btn-submit'}>Submit</Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          {showTable && (
            <div className='time-table-report-table-div'>
              <div className='export-option-wrapper'>
                {/* <Button
                            disabled={timeTableReport?.length === 0}
                            text={'Send Mail'}
                            type={'button'}
                            onClick={() => {
                                let emailArray = []
                                if (selectedFaculty === "all") {
                                    emailArray = faculties.map((faculty) => {
                                        return faculty.userEmail
                                    })
                                    branches.find((branch) => {
                                        if (branch.branchId === selectedBranch) emailArray.push(branch.userEmail)
                                    })
                                } else {
                                   faculties.find((faculty) => {
                                        if (faculty.facultyId === selectedFaculty) emailArray.push(faculty.userEmail)
                                    })
                                    branches.find((branch) => {
                                        if (branch.branchId === selectedBranch) emailArray.push(branch.userEmail)
                                    })
                                }
                                if (timeTableReport?.length > 0) {
                                    const formattedReportData = getReportData(timeTableReport);
                                    const headerContent = columns.map((col) => {
                                        return col.header.props.children.map((header) => {
                                            return header.props.children
                                        });
                                    })
                                    const headers = columns.map(col => ({ field: col.field, header: headerContent }));
                                    exportTimeTableReport(formattedReportData, headers, 'Sheet1', 'Timetable Report.xlsx', 'Mail', dispatch, emailArray, mailPayload);
                                }
                            }}
                        >
                            Send Mail
                        </Button> */}
                <Button
                  disabled={timeTableReport?.length === 0 || mailLoading}
                  text={'Send Mail'}
                  type={'button'}
                  onClick={async () => {
                    try {
                      if (selectedFaculty === 'all') {
                        const mailTasks = faculties.map(async (faculty) => {
                          // Filter the timetable data for the specific faculty
                          const facultyTimetable = timeTableReport.filter((report) => {
                            return report.batchWiseTimetable.some((batch) =>
                              batch.timetableData.some((timetable) => timetable.facultyId === faculty.facultyId),
                            )
                          })

                          // If there is timetable data for the faculty
                          if (facultyTimetable.length > 0) {
                            const formattedReportData = getReportData(facultyTimetable)

                            const headerContent = columns.map((col) => {
                              return col.header.props.children.map((header) => header.props.children)
                            })

                            const headers = columns.map((col) => ({
                              field: col.field,
                              header: headerContent,
                            }))

                            const payload = {
                              startDate: mailPayload.startDate,
                              endDate: mailPayload.endDate,
                              faculties: faculty.facultyId,
                            }

                            await exportTimeTableReport(
                              formattedReportData,
                              headers,
                              'Sheet1',
                              `Timetable Report - ${faculty.userName}.xlsx`,
                              'Mail',
                              dispatch,
                              [faculty.userEmail],
                              payload,
                            )
                          }
                        })

                        // Use Promise.all to send emails for all faculties concurrently
                        await Promise.all(mailTasks).finally(() => {
                          toast.success('Email sent successfully!', {
                            className: 'custom-toast-success',
                            progressStyle: { background: '#ffffff' },
                          })
                        })
                      } else {
                        let emailArray = []
                        faculties.find((faculty) => {
                          if (faculty.facultyId === selectedFaculty) emailArray.push(faculty.userEmail)
                        })
                        branches.find((branch) => {
                          if (branch.branchId === selectedBranch) emailArray.push(branch.userEmail)
                        })

                        if (timeTableReport?.length > 0) {
                          const formattedReportData = getReportData(timeTableReport)

                          const headerContent = columns.map((col) => {
                            return col.header.props.children.map((header) => {
                              return header.props.children
                            })
                          })

                          const headers = columns.map((col) => ({ field: col.field, header: headerContent }))
                          await exportTimeTableReport(
                            formattedReportData,
                            headers,
                            'Sheet1',
                            'Timetable Report.xlsx',
                            'Mail',
                            dispatch,
                            emailArray,
                            mailPayload,
                          )

                          toast.success('Email sent successfully!', {
                            className: 'custom-toast-success',
                            progressStyle: { background: '#ffffff' },
                          })
                        }
                      }
                    } catch (error) {
                      toast.error('Error sending emails!', {
                        className: 'custom-toast-error',
                        progressStyle: { background: '#ffffff' },
                      })
                    }
                  }}
                >
                  {mailLoading ? <CircularProgress size={24} /> : 'Send Mail'}
                </Button>

                <div className='pdf-excel-export'>
                  <Button
                    text={'Export'}
                    type={'button'}
                    onClick={() => {
                      if (timeTableReport?.length > 0) {
                        const formattedReportData = getReportData(timeTableReport)
                        const headerContent = columns.map((col) => {
                          return col.header.props.children.map((header) => {
                            return header.props.children
                          })
                        })
                        const headers = columns.map((col) => ({ field: col.field, header: headerContent }))
                        exportTimeTableReport(
                          formattedReportData,
                          headers,
                          'Sheet1',
                          'Timetable Report.xlsx',
                          'Export',
                          dispatch,
                        )
                      }
                    }}
                  >
                    <SimCardDownloadIcon />
                  </Button>

                  <Button text={'Export'} type={'button'} onClick={handleDownloadPfd}>
                    <PrintIcon />
                  </Button>
                </div>
              </div>

              <div className='printable-component' ref={printRef}>
                {timeTableReport?.length > 0 ? (
                  getReportDataRender(timeTableReport).map((timetable, index) => (
                    <div key={index}>
                      <div className='report-heading-label-div'>{timetable.classTime}</div>
                      <ReportDataTable columns={columns} value={timetable.data} />
                    </div>
                  ))
                ) : (
                  <ReportDataTable columns={columns} value={timeTableReport} />
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default TimeTableReport
